export default __webpack_public_path__ + "static/media/WasteHandlingAndDisposal_icon.491e33d8.svg";